import React, { useState, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/Survey.css";
import Header from "../components/Header";
import SectionTitle from "../components/SectionTitle";
import Footer from "../components/Footer";
import { LanguageContext } from "../LanguageContext";

const Survey = () => {
  const [answers, setAnswers] = useState({});
  const [errors, setErrors] = useState({});
  const questionRefs = useRef({});
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);

  const questions = [
  {
    id: 1,
    key: "age",
    text: language === "ko" ? "환자의 나이는 어떻게 되나요?(세)" : "What is the patient's age?",
    subtext: language === "ko" ? "What is the patient's age?" : "환자의 나이는 어떻게 되나요?(세)",
    type: "input"
  },
  {
    id: 2,
    key: "height",
    text: language === "ko" ? "키(cm)는 얼마인가요?" : "What is your height (cm)?",
    subtext: language === "ko" ? "What is your height (cm)?" : "키(cm)는 얼마인가요?",
    type: "input"
  },
  {
    id: 3,
    key: "weight",
    text: language === "ko" ? "몸무게(kg)는 얼마인가요?" : "What is your weight (kg)?",
    subtext: language === "ko" ? "What is your weight (kg)?" : "몸무게(kg)는 얼마인가요?",
    type: "input"
  },
  {
    id: 4,
    key: "ivf_count",
    text: language === "ko" ? "이전에 시도한 IVF주기 총 수는 어떻게 되나요?" : "Total number of previous IVF cycles?",
    subtext: language === "ko" ? "Total number of previous IVF cycles?" : "이전에 시도한 IVF주기 총 수는 어떻게 되나요?",
    type: "dropdown",
    options: ["0", "1", "2 이상"],
    scores: [0, 1, 2],
    description: language === "ko"
      ? "*IVF란? 체외수정. 난자와 정자를 각각 채취하여 몸 밖에서 인공적으로 수정하는 방법."
      : "*What is IVF? In vitro fertilization (IVF) is a process where eggs and sperm are collected and fertilized outside the body."
  },
  {
    id: 5,
    key: "past_pregnancy",
    text: language === "ko" ? "IVF를 통해 출산한 아이 수는 어떻게 되나요?" : "Number of live births through IVF?",
    subtext: language === "ko" ? "Number of live births through IVF?" : "IVF를 통해 출산한 아이 수는 어떻게 되나요?",
    type: "dropdown",
    options: ["0", "1", "2 이상"],
    scores: [0, 1, 2]
  },
  {
    id: 6,
    key: "uterine",
    text: language === "ko" ? "불임의 원인 - 나팔관질환을 가지고 있나요?" : "Do you have tubal disease?",
    subtext: language === "ko" ? "Do you have tubal disease?" : "불임의 원인 - 나팔관질환을 가지고 있나요?",
    type: "radio",
    options: ["yes", "no"],
    scores: [1, 0]
  },
  {
    id: 7,
    key: "eggs",
    text: language === "ko" ? "회수한 신선한 난자의 수는 어떻게 되나요?" : "Number of fresh eggs collected?",
    subtext: language === "ko" ? "Number of fresh eggs collected?" : "회수한 신선한 난자의 수는 어떻게 되나요?",
    type: "dropdown",
    options: ["0", "1", "2 이상"],
    scores: [0, 1, 2]
  },
  {
    id: 8,
    key: "ovulatory",
    text: language === "ko" ? "난자와 파트너 정자의 혼합한 수는 어떻게 되나요?" : "Eggs mixed with partner sperm?",
    subtext: language === "ko" ? "Eggs mixed with partner sperm?" : "난자와 파트너 정자의 혼합한 수는 어떻게 되나요?",
    type: "dropdown",
    options: ["0", "1 이상"],
    scores: [0, 1]
  },
  {
    id: 9,
    key: "endometriosis",
    text: language === "ko" ? "불임의 원인 - 자궁내막증을 가지고 있나요?" : "Do you have endometriosis?",
    subtext: language === "ko" ? "Do you have endometriosis?" : "불임의 원인 - 자궁내막증을 가지고 있나요?",
    type: "radio",
    options: ["yes", "no"],
    scores: [1, 0]
  },
  {
    id: 10,
    key: "male_factor",
    text: language === "ko" ? "파트너의 정자가 형태학적 이상을 가지고 있나요?" : "Does partner have abnormal sperm morphology?",
    subtext: language === "ko" ? "Does partner have abnormal sperm morphology?" : "파트너의 정자가 형태학적 이상을 가지고 있나요?",
    type: "radio",
    options: ["yes", "no"],
    scores: [1, 0]
  },
  {
    id: 11,
    key: "unexplained",
    text: language === "ko" ? "파트너의 정자 운동성에 이상이 있나요?" : "Does partner have abnormal sperm motility?",
    subtext: language === "ko" ? "Does partner have abnormal sperm motility?" : "파트너의 정자 운동성에 이상이 있나요?",
    type: "radio",
    options: ["yes", "no"],
    scores: [1, 0]
  },
  {
    id: 12,
    key: "rif",
    text: language === "ko" ? "이식된 배아의 수는 어떻게 되나요?" : "Number of embryos transferred?",
    subtext: language === "ko" ? "Number of embryos transferred?" : "이식된 배아의 수는 어떻게 되나요?",
    type: "dropdown",
    options: ["0", "1", "2 이상"],
    scores: [0, 1, 2]
  },
  {
    id: 13,
    key: "por",
    text: language === "ko" ? "저반응성 난소 증후군을 가지고 있나요?" : "Do you have poor ovarian response (POR)?",
    subtext: language === "ko" ? "Do you have poor ovarian response (POR)?" : "저반응성 난소 증후군을 가지고 있나요?",
    type: "radio",
    options: ["yes", "no"],
    scores: [1, 0]
  }
];


  const handleChange = (id, key, value, score = null) => {
    const parsedValue = score !== null ? score : parseFloat(value);
    setAnswers((prev) => ({ ...prev, [key]: parsedValue }));
    setErrors((prev) => ({ ...prev, [id]: false }));
  };

  const handleSubmit = async () => {
    const unanswered = questions.filter((q) => answers[q.key] === undefined || answers[q.key] === null || answers[q.key] === "");

    if (unanswered.length > 0) {
      const newErrors = {};
      unanswered.forEach((q) => {
        newErrors[q.id] = true;
      });
      setErrors(newErrors);

      const firstUnanswered = unanswered[0];
      const ref = questionRefs.current[firstUnanswered.id];
      if (ref) ref.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    try {
      const payload = {
        age: answers.age,
        height: answers.height,
        weight: answers.weight,
        eggs: answers.eggs,
        ivf_count: answers.ivf_count,
        endometriosis: answers.endometriosis,
        unexplained: answers.unexplained,
        past_pregnancy: answers.past_pregnancy,
        male_factor: answers.male_factor,
        uterine: answers.uterine,
        ovulatory: answers.ovulatory,
        por: answers.por,
        rif: answers.rif
      };

      const response = await axios.post("https://backend.pregmeter.com/predict", payload);
      navigate("/loading", { state: { score: response.data.pregnancy_probability } });
    } catch (error) {
      console.error("API 오류:", error);
      alert(language === "ko" ? "예측에 실패했습니다." : "Prediction failed.");
    }
  };

  return (
    <>
      {/* <Header /> */}
      <SectionTitle />
      <div className="survey-container">
        {/* <h2 className="survey-title">{language === "ko" ? "임신율 예측 자가 테스트" : "Self-Test for Pregnancy Probability"}</h2>
        <p className="survey-subtitle">{language === "ko" ? "가임기 여성의 임신 예측 테스트" : "Testing fertility prediction in fertile patients"}</p> */}
        <form className="survey-form" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
          {questions.map((q) => (
            <div
              key={q.id}
              className={`survey-question ${errors[q.id] ? "error" : ""}`}
              ref={(el) => (questionRefs.current[q.id] = el)}
            >
              <label className="question-label">
                <span className="question-number">{q.id}.</span> {q.text}
              </label>
              {q.subtext && (
                <p className="question-subtext">{q.subtext}</p>
              )}
              {q.description && (
                <p className="question-description">{q.description}</p>
              )}
              {q.type === "radio" ? (
                <div className="radio-group">
                  {q.options.map((opt, idx) => (
                    <label key={idx} className="radio-option">
                      <input
                        type="radio"
                        name={`q${q.id}`}
                        onChange={() => handleChange(q.id, q.key, opt, q.scores[idx])}
                      />
                      {opt}
                    </label>
                  ))}
                </div>
              ) : q.type === "dropdown" ? (
                <select
                  className="dropdown-select"
                  onChange={(e) =>
                    handleChange(q.id, q.key, e.target.value, q.scores[q.options.indexOf(e.target.value)])
                  }
                >
                  <option value="">{language === "ko" ? "항목 선택" : "Select an option"}</option>
                  {q.options.map((opt, idx) => (
                    <option key={idx} value={opt}>{opt}</option>
                  ))}
                </select>
              ) : (
                <input
                  type="number"
                  className="input-text"
                  placeholder={language === "ko" ? "숫자를 입력하세요" : "Enter a number"}
                  onChange={(e) => handleChange(q.id, q.key, e.target.value)}
                />
              )}
            </div>
          ))}
          <button type="submit" className="submit-button">
            {language === "ko" ? "제출하기" : "Submit"}
          </button>
        </form>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Survey;
